/** Minimal className joiner — avoids pulling clsx in for the handful of places that need it. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
